<template lang="pug">
b-row.m-0.w-100
  b-col.px-0.px-md-2(md="6")
    .zig-zag-bottom
      .acc-title(style="color:unset") {{ $t('offer.payment.details') }}
      .acc-content.px-3.d-flex.flex-column
        .acc-element
          span.acc-elt-title {{ $t('offer.payment.label') }} &nbsp; 
          span.acc-elt-val(style="font-size: 14px;" :title="$t('offer.payment.commission', { comm: reply.price.vvcComissionTtc })") {{ $t('offer.payment.amount', { amount: reply.price.totalWithVccTtc, currency: reply.price.currency }) }} 
        //- small {{ $t('offer.payment.commission', { comm: reply.price.vvcComissionTtc }) }}
        .acc-element 
          span.acc-elt-title {{ $t('offer.payment.stat') }} &nbsp; 
          span.acc-elt-val(style="color:#ffb200") {{ $t('offer.payment.pending') }}
        .acc-element 
          span.acc-elt-title {{ $t('offer.payment.ref') }} &nbsp; 
          span.acc-elt-val( :title="reply.paymentId" ) {{ reply.paymentId }}
        .acc-element(v-if="reply.payementAt")
          span.acc-elt-title {{ $t('offer.payment.payementStartedAt') }} &nbsp; 
          span.acc-elt-val {{ reply.payementAt | moment2($i18n.locale) }}
        .acc-element 
          span.acc-elt-title {{ $t('offer.payment.refVVC') }} &nbsp; 
          span.acc-elt-val(:title="reply.replyId") {{  reply.replyId }}
        //- button.acc-down-button(v-if="reply.userBillId", @click="downloadBill", :disabled="billDownloading", :class="{'acc-down-button-disabled' : billDownloading}") {{ $t('offer.payment.cta.bill') }}
  b-col.px-0.px-md-2(md="6")
    .d-flex.flex-column.justify-content-center.align-items-center.w-100.h-100.p-2.mt-n2
      .text-center {{ $t('offer.payment.hint') }}
</template>

<script>
export default {
  name: "PayementPending",
  components: {
  },
  props: {
    reply: {
      type: Object,
      default: () => {},
    },
    departureAtHarbor : {
      type: Boolean,
      default : false,
    }
  }
}

</script>